import { useCallback, useRef } from "react";

import type { Combobox as BaseCombobox } from "@base-ui/react/combobox";

import type { ComboboxVirtualizer } from "./Combobox.types";

export function useComboboxVirtualizedScroll<Value>() {
  const virtualizerRef = useRef<ComboboxVirtualizer | null>(null);

  const onItemHighlighted = useCallback(
    (
      item: Value | undefined,
      { reason, index }: BaseCombobox.Root.HighlightEventDetails,
    ) => {
      const virtualizer = virtualizerRef.current;

      if (!item || !virtualizer) {
        return;
      }

      const isStart = index === 0;
      const isEnd = index === virtualizer.options.count - 1;
      const shouldScroll =
        reason === "none" || (reason === "keyboard" && (isStart || isEnd));

      if (shouldScroll) {
        queueMicrotask(() => {
          virtualizer.scrollToIndex(index, {
            align: isEnd ? "start" : "end",
          });
        });
      }
    },
    [],
  );

  return { virtualizerRef, onItemHighlighted };
}
